
export interface ResearchLabel {
  company_id: string;
  text: string;
  id: string;
}
